import { NumberUtils } from './number.utils';

export enum CurrencyCode {
  NGN = 'NGN',
  ZAR = 'ZAR',
  USD = 'USD',
  EUR = 'EUR',
  AOA = 'AOA',
  BWP = 'BWP',
  KES = 'KES',
}

export const CurrencySymbols = new Map([
  [CurrencyCode.NGN, { symbol: '₦', isRHSymbol: false }],
  [CurrencyCode.ZAR, { symbol: 'R', isRHSymbol: false }],
  [CurrencyCode.EUR, { symbol: '€', isRHSymbol: false }],
  [CurrencyCode.USD, { symbol: '$', isRHSymbol: false }],
  [CurrencyCode.AOA, { symbol: 'AOA', isRHSymbol: false }],
  [CurrencyCode.KES, { symbol: 'KSh', isRHSymbol: false }],
  [CurrencyCode.BWP, { symbol: 'P', isRHSymbol: false }],
]);

export class CurrencyHelper {


  public static getCurrencyVal(amount: number, exchRate: number) {
    return amount * exchRate;
  }

  public static FormatAmountToCurrency(amount?: Amount | null, isPerMonth = false, format = '2-2') {
    if (amount?.value === null || amount?.value === undefined || isNaN(Number(amount?.value))) {
      return ``;
    }
    const isNegative = !!`${amount?.value}`.includes('-');
    const formattedNumber = NumberUtils.FormatToDecimal(amount.value, format);
    // TODO: Remove CurrencySymbols map here - get this from app store instead.
    const currency = amount?.currencySymbol ? { symbol: amount?.currencySymbol, isRHSymbol: false } : amount.currencyCode ? CurrencySymbols.get(amount.currencyCode) : { symbol: '', isRHSymbol: false };
    return `${isNegative ? '-' : ''}${!currency?.isRHSymbol ? currency?.symbol : ''}${formattedNumber.replace('-', '')}${currency?.isRHSymbol ? currency?.symbol : ''}${isPerMonth ? 'pm' : ''}`;
  }
}

export class LocalPrice {
  currency!: string;
  amount!: number;
}

export class CurrencyData {
  symbol!: string;
  code!: string;
  exchRate?: number;
}

export interface Amount {
  currencyCode?: CurrencyCode;
  currencySymbol?: string;
  localPrice?: null | string | number | LocalPrice;
  value: null | undefined | string | number;
}